<template lang="pug">
  div#popup
    span(@click='close')
      ods-icon.iconClose(name="close" size="20")
    div.containerDataPopup
      ods-row(type="flex" justify='')
        span.containerDataPopup__category {{ datosFinal.properties.brandName }} {{ datosFinal.properties.color }} -
        span
         span.containerDataPopup__brand
         span {{ datosFinal.properties.vehiclePlateIdentifier }}
    div.containerValuesPopup
      ods-tag(type="secondary") {{ $t(datosFinal.properties.category) }}
    //  ods-scrollbar(wrap-class='ods-scrollbar__wrap')
        div.maxSizePopup
          ods-row(type="flex" justify='space-between')
            ods-col(:span='12')
              span.tipo Modelo:
              span.valor {{ datosFinal.properties.brandName }}
            ods-col(:span='12')
              span.tipo Color:
              span.valor {{ datosFinal.properties.color }}
            ods-col.ods-mb-0(:span='24')
              span.tipo Categoría:
              span.valor {{ $t(datosFinal.properties.category) }}
</template>

<script>
import StatusCero from '@/components/StatusCero'
export default {
  name: 'PopupBus',
  props: {
    datosFinal: {
      // type: Array
    }
    // dataCompare: {
    //   type: Boolean
    // },
    // dataCompareLoad: {
    //   type: Boolean
    // },
    // stationName: {
    //   type: String
    // },
    // valorComparado: {
    //   type: String
    // }
  },
  methods: {
    close () {
      var eventSetBus = new CustomEvent('setPopupBus', { detail: false })
      document.dispatchEvent(eventSetBus)
      var eventSetVehicle = new CustomEvent('setPopupVehicle', { detail: false })
      document.dispatchEvent(eventSetVehicle)
      this.$parent.$refs.verticalGeneric.updateSelectedStation()
      document.getElementById('dataIframe').contentWindow.resetEntityCards()
    }
  },
  components: {
    StatusCero
  },
  mounted () {
    console.log('datos', this.datosFinal)
  }
}
</script>

<style scoped lang="scss">

#popup {
  background: $--color-white;
  border-radius: 5px;
  bottom: rem(62);
  // display: none;
  // left: calc(24px + 72px);
  left: rem(16);
  // padding-right: rem(24);
  padding: rem(16) rem(32);
  padding-top: rem(32);
  position: absolute;
  transition: width 0.4s, min-width 0.4s, opacity 0.4s;
  width: auto;
  z-index: 10;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  .iconClose {
    cursor: pointer;
    position: absolute;
    top: rem(8);
    right: rem(8);
  }
}
.containerDataPopup {
    /* padding-bottom: rem(16); */
    margin-bottom: rem(16);
    /* border-bottom: 1px solid $--color-neutral-3; */
    margin-right: rem(8);
    font-weight: 500;
    &__category{
      color: $--color-grey;
      margin: 0 rem(3) 0 0;
    }
    &__brand{
      font-weight: normal;
    }
  }
  .containerValuesPopup{
    margin-bottom: rem(16);
  }

.maxSizePopup {
  // max-height: rem(100);
  // padding-right: rem(24);
  text-transform: uppercase;
  div {
    margin-bottom: rem(16);
    font-size: rem(10);
    .tipo {
      font-weight: bold;
      margin-right: rem(8);
    }
    .valor {
      color: $--color--grey-medium;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PopupBus.vue